import type { InjectionKey, Ref } from 'vue';

interface Notification {
  text: string,
  onDimiss?: () => unknown,
  dismissible?: boolean,
}

interface ShowNotification {
  success: (item: Notification) => number;
  error: (item: Notification) => number;
  info: (item: Notification) => number;
}

export const PageContext: InjectionKey<{
  isPageLoading: Ref<boolean>;
  showNotification: ShowNotification;
}> = Symbol('PageContext');

interface Pagination {
  amount_per_page: number;
  current_page: number;
  items_left: number;
  pages_left: number;
  total_items: number;
  total_pages: number;
}

export type Metadata = {
  pagination: Pagination
};

export interface ResponseData<T = any> {
  data: T;
  metadata: Metadata;
}
